module.exports = __webpack_public_path__ + "static/joc_04-9386dc0c77a38c7338c66cd0f1d9fbd6.jpg";